import ArrowForward from "@mui/icons-material/ArrowForwardIos";
import { Grid } from "@mui/material";
import { Link } from "react-router-dom";
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Story from "../../Assets/Img/instastory.svg";
import Man from "../../Assets/Img/man.png";
import Posts from "../../Assets/Img/postframe.svg";
import Reels from "../../Assets/Img/reel.svg";
import Trophy from "../../Assets/Img/Trophy.svg";
import Woman from "../../Assets/Img/woman.png";
import YoutubeLive from "../../Assets/Img/youtubelive.svg";
import YoutubeShorts from "../../Assets/Img/youtubeshorts.svg";
import YoutubeVideos from "../../Assets/Img/youtubevideos.svg";
import CustomPieChart from "../../Common/Components/Charts/PieChart";
import CircularProgress from "../../Common/Components/CircularLoader";
import axiosMain from "../../http/axiosMain";
import "./Insights.css";

// Register the required components
ChartJS.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const Bardata = [
  { name: "Likes", value: 6000, fill: "#FDD5DC" },
  { name: "Comments", value: 8000, fill: "#B3EBE8" },
  { name: "Saves", value: 4000, fill: "#D0FCD7" },
  { name: "Shares", value: 3000, fill: "#B9F3FC" },
];

function Insights() {
  const navigate = useNavigate();
  const chartContainer = useRef(null);
  const chartInstance = useRef(null);
  const [topPerformingCampaigns, setTopPerformingCampaigns] = useState([]);
  const [isCampaignsLoading, setIsCampaignsLoading] = useState(true);

  const [campaignStats, setCampaignStats] = useState({});
  const [isCampaignStatsLoading, setIsCampaignStatsLoading] = useState(true);
  console.log(campaignStats);
  // Dhruv Rajpurohit
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // "Dec"

    const suffix =
      day === 1 || day === 21 || day === 31
        ? "st"
        : day === 2 || day === 22
        ? "nd"
        : day === 3 || day === 23
        ? "rd"
        : "th";

    return `${day}${suffix} ${month}`;
  };
  // Dhruv Rajpurohit
  const getTopPerformingCampaigns = async () => {
    try {
      setIsCampaignsLoading(true);
      const resp = await axiosMain.get("/api/v1/campaigns"); // Make sure the endpoint matches your API.
      // console.log("Dhruv......",resp);

      if (resp.status === 200) {
        setTopPerformingCampaigns(resp.data?.campaigns);
        // console.log("hhfihgiji",kanj);
      } else {
        toast.error(resp.data?.message || "Something went wrong", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setIsCampaignsLoading(false);
    }
  };

  useEffect(() => {
    getTopPerformingCampaigns();
  }, []);

  const getCampaignStats = (stats) => {
    return [
      { name: "Ongoing", value: stats?.ongoing || 0, fill: "#D0FCD7" },
      { name: "Scheduled", value: stats?.scheduled || 0, fill: "##FDD5DC" },
      { name: "Completed", value: stats?.completed || 0, fill: "#B9F3FC" },
    ];
  };

  const getCampaigns = async () => {
    try {
      setIsCampaignStatsLoading(true);
      const resp = await axiosMain.get("api/v1/campaigns-statistics");
      if (resp.status === 200 && resp.data?.success) {
        setCampaignStats(resp.data?.statistics || {});
      } else {
        toast.error(resp.data?.message || "Something went wrong", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setIsCampaignStatsLoading(false);
    }
  };

  const handleEngagementClick = () => {
    navigate("/engagement");
  };
  const handleReachClick = () => {
    navigate("/reach");
  };

  const handleInstagramClick = () => {
    const platform = "Instagram";
    navigate("/insights/instagram", { state: { platform } });
  };

  const handleYouTubeClick = () => {
    const platform = "YouTube";
    navigate("/insights/youtube", { state: { platform } });
  };

  useEffect(() => {
    if (chartContainer && chartContainer.current && Bardata) {
      const ctx = chartContainer.current.getContext("2d");

      // Create the Chart instance if it doesn't exist
      if (!chartInstance.current) {
        chartInstance.current = new Chart(ctx, {
          type: "bar",
          data: {
            labels: Bardata.map((entry) => entry.name),
            datasets: [
              {
                label: "Reach",
                data: Bardata.map((entry) => entry.value),
                backgroundColor: Bardata.map((entry) => entry.fill),
                borderColor: Bardata.map((entry) => entry.fill),
                borderWidth: 2,
                barThickness: 25,
              },
            ],
          },
          options: {
            indexAxis: "y",
            elements: {
              bar: {
                borderWidth: 2,
              },
            },
            responsive: true,
            plugins: {
              legend: {
                display: false,
              },
            },
            defaultFontFamily: "'Poppins', sans-serif",
            defaultFontColor: "brown",
          },
        });

        // Ensure chartContainer.current exists before adding event listener
        if (chartContainer.current) {
          // Example event listener (you can replace this with your own logic)
          chartContainer.current.addEventListener("click", () => {
            console.log("Chart container clicked!");
          });
        }
      } else {
        // Update the Chart data if it already exists
        chartInstance.current.data.labels = Bardata.map((entry) => entry.name);
        chartInstance.current.data.datasets[0].data = Bardata.map(
          (entry) => entry.value
        );
        chartInstance.current.data.datasets[0].backgroundColor = Bardata.map(
          (entry) => entry.fill
        );
        chartInstance.current.data.datasets[0].borderColor = Bardata.map(
          (entry) => entry.fill
        );

        chartInstance.current.update(); // Update the chart
      }
    }
  }, [Bardata]);

  useEffect(() => {
    getCampaigns();
  }, []);

  return (
    <>
      <div className="State wrapping-box">
        <div className="wrapping-box-content">
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            className="first-container"
          >
            <Grid item xs={12} sm={12} md={4}>
              <div className="left-container">
                <div className="options-content">
                  <span className="platformtitle">Total Campaigns Posted</span>
                  {/* <div className="right-top-actions">
                    <span>View All</span>
                    <ArrowForward sx={{ width: "14px" }} />
                  </div> */}
                </div>
                {!isCampaignStatsLoading && campaignStats?.totalCampaigns ? (
                  <>
                    <div className="pie-chart">
                      <CustomPieChart
                        data={getCampaignStats(campaignStats)}
                        width={332}
                        height={332}
                      />
                    </div>
                    <div className="bottom-content">
                      <span className="number-of-campaigns">
                        Total {campaignStats?.totalCampaigns || 0} campaigns
                        posted
                      </span>
                    </div>
                  </>
                ) : isCampaignStatsLoading ? (
                  <CircularProgress />
                ) : (
                  <div className="no-data">
                    <small>No Campaigns Found.</small>
                  </div>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <Grid
                container
                rowSpacing={2}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                className="right-container"
              >
                <Grid item xs={12} sm={12} md={6} className="social-corner">
                  <div className="ig-box" onClick={handleInstagramClick}>
                    <div className="text-content">
                      <span>Instagram</span>
                    </div>
                    <div className="socials-stats">
                      <div className="reels">
                        <img src={Reels} alt="reels" />
                        <p>12</p>
                        <small>Reels</small>
                      </div>
                      <div className="reels">
                        <img src={Story} alt="story" />
                        <p>12</p>
                        <small> Story</small>
                      </div>
                      <div className="reels">
                        <img src={Posts} alt="posts" />
                        <p>12</p>
                        <small>Posts</small>
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={12} md={6} className="social-corner">
                  <div className="ig-box">
                    <div className="text-content">
                      <span>Total Engagement Score</span>
                    </div>
                    <div
                      className="number-content"
                      onClick={handleEngagementClick}
                    >
                      <p>6%</p>
                      <small onClick={handleEngagementClick}>
                        Audience Engaged
                      </small>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={12} md={6} className="social-corner">
                  <div className="ig-box" onClick={handleYouTubeClick}>
                    <div className="text-content">
                      <span>Youtube</span>
                    </div>
                    <div className="socials-stats">
                      <div className="reels">
                        <img src={YoutubeShorts} alt="reels" />
                        <p>12</p>
                        <small>Shorts</small>
                      </div>
                      <div className="reels">
                        <img src={YoutubeVideos} alt="story" />
                        <p>12</p>
                        <small> Videos</small>
                      </div>
                      <div className="reels">
                        <img src={YoutubeLive} alt="posts" />
                        <p>12</p>
                        <small>Live</small>
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={12} md={6} className="social-corner">
                  <div className="ig-box">
                    <div className="text-content">
                      <span>Total Reach</span>
                    </div>
                    <div className="number-content" onClick={handleReachClick}>
                      <p>10,234</p>
                      <small onClick={handleReachClick}>Audience Reached</small>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div style={{ width: "100%", height: "95%" }}>
            <canvas
              ref={chartContainer}
              width={1300}
              height={320}
              style={{
                width: "100%",
                height: "90%",
                backgroundColor: "rgba(255, 255, 255, 1)",
                borderRadius: "10px",
              }}
            />
          </div>

          <div className="third-container mt-3">
            <div className="container-fluid MainBox p-0">
              <div className="campaign-performance-box Box">
                <div className="platformtitle">
                  <span>Top Performing campaigns</span>
                </div>
                <div className="campaign-names">
                  {/* <div className="campaign-date">
                    <ul>
                      <li className="name">Secret Santa</li>
                    </ul>
                    <p>12th Dec</p>
                  </div>
                  <div className="campaign-date">
                    <ul>
                      <li className="name">Great Indian Sale</li>
                    </ul>
                    <p>3rd Oct</p>
                  </div>
                  <div className="campaign-date">
                    <ul>
                      <li className="name">Big Billion Days</li>
                    </ul>
                    <p>26th Aug</p>
                  </div> */}
                  {/* Dhruv Rajpurohit */}
                  <div className="campaign-names">
                    {isCampaignsLoading ? (
                      <div style={{ textAlign: "center" }}>
                        Loading campaigns...
                      </div>
                    ) : (
                      (() => {
                        const filteredCampaigns = topPerformingCampaigns.filter(
                          (campaign) => new Date(campaign.end_date) < new Date()
                        );

                        return filteredCampaigns.length === 0 ? (
                          <div style={{ textAlign: "center" }}>
                            No campaigns found
                          </div>
                        ) : (
                          filteredCampaigns.map((campaign, index) => (
                            <div className="campaign-date" key={index}>
                              <ul>
                                <li className="name">
                                  {campaign.campaign_title}
                                </li>
                              </ul>
                              <p>{formatDate(campaign.end_date)}</p>
                            </div>
                          ))
                        );
                      })()
                    )}
                  </div>

                  {/* Dhruv Rajpurohit */}
                </div>
              </div>
              {/* <div className="influencer-performance-box Box">
                <div className="platformtitle">
                  <span>Top Performing Influencers</span>
                </div>
                <div className="influencer-wrapper-container mt-3">
                  <div className="influencer-1">
                    <div className="nameofinfluencer">
                      <img src={Man} alt="nameofinfluencer" />
                      <p>
                      <Link to="/InfluencerStats" className="no-style-link">Ashish Chanchlani</Link>
                      </p>
                    </div>
                    <div className="audience-stats">
                      <div className="d-flex">
                        <p>6K</p>
                        <span>
                          Audience <br />
                          Reached
                        </span>
                      </div>
                      <div className="d-flex">
                        <p>10%</p>
                        <span>
                          Audience
                          <br /> Engaged
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="trophy-image">
                    <img src={Trophy} alt="trophy" />
                  </div>
                  <div className="influencer-1">
                    <div className="nameofinfluencer">
                      <img src={Woman} alt="nameofinfluencer" />
                      <p>
                      <Link to="/InfluencerStats" className="no-style-link">Varsha Thakkar</Link>  
                      </p>
                    </div>
                    <div className="audience-stats">
                      <div className="d-flex">
                        <p>4K</p>
                        <span>
                          Audience <br />
                          Reached
                        </span>
                      </div>
                      <div className="d-flex">
                        <p>8%</p>
                        <span>
                          Audience
                          <br /> Engaged
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {isCampaignsLoading ? (
                <div style={{ textAlign: "center" }}>Loading campaigns...</div>
              ) : (
                (() => {
                  const filteredCampaigns = topPerformingCampaigns.filter(
                    (campaign) => new Date(campaign.end_date) < new Date()
                  );

                  return filteredCampaigns.length === 0 ? (
                    <div style={{ textAlign: "center" }}>
                      No influencers yet
                    </div>
                  ) : (
                    <div className="influencer-performance-box Box">
                      <div className="platformtitle">
                        <span>Top Performing Influencers</span>
                      </div>
                      <div className="influencer-wrapper-container mt-3">
                        <div className="influencer-1">
                          <div className="nameofinfluencer">
                            <img src={Man} alt="nameofinfluencer" />
                            <p>
                              <Link
                                to="/InfluencerStats"
                                className="no-style-link"
                              >
                                Ashish Chanchlani
                              </Link>
                            </p>
                          </div>
                          <div className="audience-stats">
                            <div className="d-flex">
                              <p>6K</p>
                              <span>
                                Audience <br />
                                Reached
                              </span>
                            </div>
                            <div className="d-flex">
                              <p>10%</p>
                              <span>
                                Audience
                                <br /> Engaged
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="trophy-image">
                          <img src={Trophy} alt="trophy" />
                        </div>
                        <div className="influencer-1">
                          <div className="nameofinfluencer">
                            <img src={Woman} alt="nameofinfluencer" />
                            <p>
                              <Link
                                to="/InfluencerStats"
                                className="no-style-link"
                              >
                                Varsha Thakkar
                              </Link>
                            </p>
                          </div>
                          <div className="audience-stats">
                            <div className="d-flex">
                              <p>4K</p>
                              <span>
                                Audience <br />
                                Reached
                              </span>
                            </div>
                            <div className="d-flex">
                              <p>8%</p>
                              <span>
                                Audience
                                <br /> Engaged
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Insights;
